import { render, staticRenderFns } from "./InvestmentAccount.vue?vue&type=template&id=98d908d0"
import script from "./InvestmentAccount.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports